import React, { Component } from 'react'
// import {Card } from 'antd'
import SideMenu from './side.admins';

export class Admins extends Component {
    render() {
        return (
            <div>
                <div>
                            <SideMenu />
                </div>
            </div>
        )
    }
}

export default Admins
